// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2Rp7n","header":"MessagesList_header__28ASZ","chat":"MessagesList_chat__c_K-O"};